<template>
    <div class="md:hidden" v-show="opened">
        <div class="fixed inset-0 flex z-40">
            <transition
                enter-active-class="transition-opacity ease-linear duration-300"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition-opacity ease-linear duration-300"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div class="fixed inset-0" v-show="visible">
                    <div class="absolute inset-0 bg-gray-600 opacity-75" />
                </div>
            </transition>

            <transition
                enter-active-class="transition ease-in-out duration-300 transform"
                enter-class="-translate-x-full"
                enter-to-class="translate-x-0"
                leave-active-class="transition ease-in-out duration-300 transform"
                leave-class="translate-x-0"
                leave-to-class="-translate-x-full"
            >
                <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-gray-900" v-show="visible">
                    <div class="absolute top-0 right-0 -mr-14 p-1">
                        <button aria-label="Close sidebar" class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600" @click="$emit('close')">
                            <svg
                                class="h-6 w-6 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    d="M6 18L18 6M6 6l12 12"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                />
                            </svg>
                        </button>
                    </div>

                    <div class="flex-shrink-0 flex items-center justify-center h-16 px-4">
                        <a href="http://apexo.ca/">
                            <img alt="ApexO" class="h-12 w-auto" src="../../assets/logo.png">
                        </a>
                    </div>

                    <div class="mt-5 flex-1 h-0 overflow-y-auto">
                        <nav class="px-2 space-y-2">
                            <!--                            <nav-item :text="$t('global.nav.dashboard')" view="dashboard" />-->

                            <nav-item :text="$t('global.nav.orders')" view="orders" />

                            <nav-item :text="$t('global.nav.activations')" view="activations" />

                            <!-- <nav-item :text="$t('global.nav.deliveries')" view="deliveries" /> -->
                        </nav>
                    </div>

                    <div class="flex-shrink-0 flex p-4">
                        <div class="flex-shrink-0 group block">
                            <div class="flex items-center">
                                <div>
                                    <img alt="" class="inline-block h-9 w-9 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80">
                                </div>

                                <div class="ml-3">
                                    <p class="text-base leading-6 font-medium text-gray-300">
                                        {{ `${authUser.first_name} ${authUser.last_name}` }}
                                    </p>

                                    <p class="text-sm leading-5 font-medium text-gray-500 transition ease-in-out duration-150 hover:text-gray-700" @click="logOut">
                                        {{ $t('global.setting.dropdown.disconnect') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="flex-shrink-0 w-14">
                <!-- Dummy element to force sidebar to shrink to fit close icon -->
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import NavItem from './NavItem.vue';

    export default {
        components: { NavItem },

        props: {
            visible: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                opened: this.visible,
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),
        },

        watch: {
            visible(newValue) {
                if (newValue) {
                    this.opened = this.visible;
                    return;
                }

                setTimeout(() => {
                    this.opened = this.visible;
                }, 300);
            },
        },

        methods: {
            ...mapActions([
                'clearAuthUser',
            ]),

            logOut() {
                this.clearAuthUser();
            },
        },
    };
</script>
